var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lyd_av_p\\xE5_small",
    "data-name": "Lyd av/p\\xE5 small",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.579,
    height: 19.699,
    viewBox: "0 0 23.579 19.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M13.825,10.216a.953.953,0,0,0-.425-.1.987.987,0,0,0-.616.215L8.771,13.572H5.52a.988.988,0,0,0-.985.985v4.925a.988.988,0,0,0,.985.985H8.771L12.785,23.7a1,1,0,0,0,.616.215.953.953,0,0,0,.425-.1.985.985,0,0,0,.56-.887V11.109A.987.987,0,0,0,13.825,10.216Z",
    transform: "translate(-4.535 -7.17)",
    fill: "#4b2f3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M30.714,16.6a13.44,13.44,0,0,0-4.026-9.635.74.74,0,0,0-1.04,1.053A11.963,11.963,0,0,1,29.23,16.6h0a11.988,11.988,0,0,1-3.583,8.582.739.739,0,0,0-.006,1.047.722.722,0,0,0,.523.222.738.738,0,0,0,.517-.215A13.411,13.411,0,0,0,30.714,16.6Z",
    transform: "translate(-7.134 -6.752)",
    fill: "#4b2f3e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M26.474,16.964h0A10,10,0,0,0,23.593,9.89a.74.74,0,0,0-1.053,1.04A8.546,8.546,0,0,1,25,16.97h0a8.546,8.546,0,0,1-2.456,6.04.742.742,0,0,0,.523,1.262.722.722,0,0,0,.523-.222,10.055,10.055,0,0,0,2.887-7.086Z",
    transform: "translate(-6.749 -7.115)",
    fill: "#4b2f3e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M20.035,12.8a.74.74,0,0,0-1.053,1.04A4.927,4.927,0,0,1,20.4,17.326h0a4.948,4.948,0,0,1-1.416,3.485.742.742,0,0,0,.523,1.262.722.722,0,0,0,.523-.222,6.39,6.39,0,0,0,1.841-4.519h0A6.376,6.376,0,0,0,20.035,12.8Z",
    transform: "translate(-6.306 -7.476)",
    fill: "#4b2f3e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumnIcon);
export default __webpack_public_path__ + "static/media/volumn-icon.7d1580b97a6f1f748b5f4a7097c7278b.svg";
export { ForwardRef as ReactComponent };